// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Franquias_BuscaFranquiasResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /franquias/buscaFranquias
 *
 * Returns the franquias map keyed by franquia_id, plus tally fields
 * (cidades/estados/paises/idiomas) aggregated from each franquia's
 * AreasAtuacao payload.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Franquias_BuscaFranquiasResponseDados {
franquias: Record<number | string, unknown>
cidades: number
estados: number
paises: number
idiomas: number
}

export type Franquias_BuscaFranquiasResponse = ApiResponse<Franquias_BuscaFranquiasResponseDados>;

registerResponseContract('Franquias_BuscaFranquiasResponse', {
  franquias: { type: 'object',  required: true },
  cidades:   { type: 'number',  required: true },
  estados:   { type: 'number',  required: true },
  paises:    { type: 'number',  required: true },
  idiomas:   { type: 'number',  required: true },
})
